import { CATEGORY, PAGE_ROOT } from '@shared/model/constants/routes'

export const STATUS_CODE = {
  DUPLICATE_NAME: 409,
} as const

export const CONTENT_TEMPLATE_ROOT_PATH = `/${CATEGORY.ma}/${PAGE_ROOT.contentSetting}/${PAGE_ROOT.contentTemplate}`
